import { createAPIModule } from 'utility/redux/apiModuleHelpers';
// import { createSelector } from 'reselect';

const getStateSlice = (state) => state.api.storage.block.volume.update;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'STORAGE_BLOCK_VOLUME_UPDATE',
	method: 'POST',
	url: '/storage/block/volume/update.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
